/**
 * Specifies the enum options for resize direction of the TextArea sections.
 */
export var TextAreaResizeEnum;
(function (TextAreaResizeEnum) {
    /**
     * `both`&mdash;TextArea can be resized both vertically and horizontally.
     */
    TextAreaResizeEnum["both"] = "both";
    /**
     * `horizontal`&mdash;TextArea can be resized only horizontally.
     */
    TextAreaResizeEnum["horizontal"] = "horizontal";
    /**
     * `vertical`(Default) &mdash;TextArea can be resized only vertically.
     */
    TextAreaResizeEnum["vertical"] = "vertical";
    /**
     * `none`&mdash;TextArea can not be manually resized.
     */
    TextAreaResizeEnum["none"] = "none";
})(TextAreaResizeEnum || (TextAreaResizeEnum = {}));
